<template>
  <AppForm :appArray='appArray' />
</template>

<script>
import AppForm from '../publicCom/AppForm.vue'
import { isEmpty } from '@/utils/common'
import { flightMode, lteStatus, powerStatus, tcpStatus, zigbeeParamsStatus } from '@/utils/convert'

export default {
  props: {
    deviceType: {
      type: Object,
      default: () => ({})
    },
    deviceProperty: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    AppForm
  },
  watch: {
    deviceType: {
      handler: function (newVal) {
        this.appArray = { ...newVal }.deviceTypePropertyList

        this.appArray.forEach(item => {
          let val = this.deviceProperty[item.code]
          // 没匹配上的  空的直接显示 --
          if (!this.deviceProperty || isEmpty(val)) {
            item.content = '--'
            return
          }
          // 剩下的非空根据code进行匹配
          switch (item.code) {
            case 'powerStatus':
              val = this.$t(powerStatus[val].title)
              break
            case 'parameterStatus':
              val = this.$t(zigbeeParamsStatus[val].title)
              break
            case 'tcpStatus':
              val = this.$t(tcpStatus[val].title)
              break
            case 'lteStatus':
              val = this.$t(lteStatus[val].title)
              break
            case 'flightMode':
              val = this.$t(flightMode[val].title)
              break
          }

          item.content = val || '--'
        })
      }
    }
  },
  data () {
    return {
      appArray: []
    }
  }
}
</script>

<style>
</style>
